import { useTranslation } from 'react-i18next';
import { Icon } from '@/components/icons';

export function NotFoundPage() {
  const { t } = useTranslation();

  return (
    <div className="page-empty" role="alert">
      <Icon name="noAccess" size={64} aria-hidden="true" />
      <h2>{t('error.notFound')}</h2>
      <p>{t('error.notFoundDesc')}</p>
      <a href="/" className="btn btn--primary" aria-label={t('error.goHome')}>{t('error.goHome')}</a>
    </div>
  );
}
